// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--c3fc5";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--52cd6";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--a7766";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--e0698";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--a9367";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--7f4de";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--7ff70";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--76d91";